import { Injectable } from '@angular/core';

export class ApplicationConfiguration {
    /**
     * Environment dev | stage | prod
     */
    environment: string;

    /**
     * Warranty application frontend URL
     */
    frontendUrl: string;

    /**
     * Machinery backend URL
     */
    machineryBackendUrl: string;

    /**
     * Warranty application backend URL
     */
    warrantyBackendUrl: string;

    /**
     * Kemppi IAM URL
     */
    kemppiIamUrl: string;

    /**
     * Kemppi IAM Client ID
     */
    kemppiIamClientId: string;
}

@Injectable()
export class AppConfigService {
    constructor() { }

    get config(): ApplicationConfiguration {
        // this is set in main.ts which loads /config.json with AJAX
        return window['config'];
    }
}
